// extracted by mini-css-extract-plugin
module.exports = {"link":"Link-link-1rgM9","to":"Link-to-6fmSq"};